// src/components/UniProjectPage.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './UniProjectPage.css';
import { LanguageContext } from '../translations/LanguageContext';
import Footer from '../components/Footer'; // Importing the Footer component

function UniProjectsPage() {
  const { language, translations } = useContext(LanguageContext);
  const pageContent = translations[language].uniProjectsPage;

  return (
    <div className="uni-project-page">
      <div className="uni-hero-section">
        <h1 className="uni-hero-title">{pageContent.title}</h1>
        <div className="uni-hero-text">
          <p>
            {pageContent.lines[0]}<br />
            {pageContent.lines[1]}<br />
            <span className="faded-text">
              {pageContent.lines[2]}<br />
              {pageContent.lines[3]}
            </span>
          </p>
        </div>
      </div>

      <div className="uni-project-grid">
        <Link to="/uni-projects/project-module-web" className="uni-project-link">
          <div className="uni-project-card">
            <img
              src="/assets/ProjectmoduleWeb.png"
              alt="Project Module Web"
              className="uni-project-image"
            />
            <p className="uni-project-label">{pageContent.project1}</p>
          </div>
        </Link>

        <Link to="/uni-projects/generative-design-x-ai" className="uni-project-link">
          <div className="uni-project-card">
            <img
              src="/assets/WeatherFingerprint.png"
              alt="Generative Design X AI Project"
              className="uni-project-image"
            />
            <p className="uni-project-label">{pageContent.project2}</p>
          </div>
        </Link>
        
        <Link to="/uni-projects/mobile-applications" className="uni-project-link">
          <div className="uni-project-card">
            <img
              src="/assets/MobileApplications.png" 
              alt="Mobile Applications"
              className="uni-project-image"
            />
            <p className="uni-project-label">{pageContent.project3}</p>
          </div>
        </Link>
        
        <Link to="/uni-projects/personal-health-x-ai" className="uni-project-link">
          <div className="uni-project-card">
            <img
              src="/assets/PersonalHealthXAI.png"
              alt="Personal Health x AI"
              className="uni-project-image"
            />
            <p className="uni-project-label">{pageContent.project4}</p>
          </div>
        </Link>

        <div className="uni-project-card">
          <img
            src="/assets/ProjectPlaceholder.png"
            alt="Coming Soon"
            className="uni-project-image"
          />
          <p className="uni-project-label">Coming Soon</p>
        </div>

        <div className="uni-project-card">
          <img
            src="/assets/ProjectPlaceholder.png"
            alt="Coming Soon"
            className="uni-project-image"
          />
          <p className="uni-project-label">Coming Soon</p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default UniProjectsPage;
